<div class="mijn-overzicht-template-skeleton">
    @if (breadcrumb) {
        <div data-bb="breadcrumb" class="ap-flex ap-flex-row ap-flex-gap-2 margin-bottom-1 margin-top-fix">
            <div class="mijn-overzicht-template-skeleton__breadcrumb-arrow">
                <ap-paragraph-skeleton [rows]="1"></ap-paragraph-skeleton>
            </div>
            <div class="mijn-overzicht-template-skeleton__breadcrumb-label">
                <ap-paragraph-skeleton [rows]="1"></ap-paragraph-skeleton>
            </div>
        </div>
    }

    <div class="mijn-overzicht-template-skeleton__title margin-top-05 margin-bottom-1">
        <ap-paragraph-skeleton [rows]="1"></ap-paragraph-skeleton>
    </div>

    @if (subtitle || amount) {
        <div class="margin-top--05 margin-bottom-05">
            <div class="ap-flex ap-flex-row ap-flex-gap-2">
                <div class="ap-flex-1">
                    @if (subtitle) {
                        <div class="mijn-overzicht-template-skeleton__subtitle">
                            <ap-paragraph-skeleton [rows]="1"></ap-paragraph-skeleton>
                        </div>
                    }
                </div>
                <div>
                    @if (amount) {
                        <div class="mijn-overzicht-template-skeleton__amount">
                            <ap-paragraph-skeleton [rows]="1"></ap-paragraph-skeleton>
                        </div>
                    }
                </div>
            </div>
        </div>
    }
    @if (primaryAction || secondaryAction) {
        <div class="mijn-overzicht-template-skeleton__buttons ap-flex ap-flex-row ap-flex-gap-2">
            @if (primaryAction) {
                <ap-button-skeleton
                    data-bb="primaryAction"
                    class="mijn-overzicht-template-skeleton__primary"
                    [ngClass]="secondaryAction ? 'ap-flex-basis-sm-50' : 'ap-flex-basis-sm-100'"
                >
                </ap-button-skeleton>
            }
            @if (secondaryAction) {
                <ap-button-skeleton
                    data-bb="secondaryAction"
                    class="mijn-overzicht-template-skeleton__secondary"
                    [ngClass]="primaryAction ? 'ap-flex-basis-sm-50' : 'ap-flex-basis-sm-100'"
                >
                </ap-button-skeleton>
            }
        </div>
    }
</div>
